<template>
<div class="chapter">
<div class="inner_page">
<div class="dedicationPage">
<a id="title16"></a>
<div class="p-c"><span>To Claudia Lucia Capitanio, with my thanks.</span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781459262812_ded01.vue?1db25612